import { render, staticRenderFns } from "./ModalPalettes.vue?vue&type=template&id=9d07647a&scoped=true"
import script from "./ModalPalettes.vue?vue&type=script&lang=js"
export * from "./ModalPalettes.vue?vue&type=script&lang=js"
import style0 from "./ModalPalettes.vue?vue&type=style&index=0&id=9d07647a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d07647a",
  null
  
)

export default component.exports